import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useNavigate } from 'react-router-dom'
import "../style/Login.css";
import { Container } from "react-bootstrap";
import { AuthContext } from '../App';
import Modal from 'react-bootstrap/Modal';



const Login = () => {

    const navigate = useNavigate();
    const { dispatch } = React.useContext(AuthContext);
    const initialState = {
        email: "",
        password: "",
        isSubmitting: false,
        errorMessage: null
    };
    const [data, setData] = React.useState(initialState);
    const [showModal, setShowModal] = React.useState(false);
    const [accounts, setAccounts] = React.useState(null);

    const handleInputChange = event => {
        setData({
            ...data,
            [event.target.name]: event.target.value
        });
    };
    const handleFormSubmit = event => {
        event.preventDefault();
        setData({
            ...data,
            isSubmitting: true,
            errorMessage: null
        });
        fetch("api/auth/token", {
            method: "post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: data.email,
                password: data.password
            })
        })
            .then(res => {
                if (res.ok) {
                    return res.json();
                }
                throw res;
            })
            .then(resJson => {
                // console.log(resJson);
                if (resJson.status === 'SUCCESS') {
                    if (resJson.dualAccount) {
                        setAccounts(resJson);
                        setShowModal(true);
                        setData({
                            ...data,
                            isSubmitting: false
                        });
                    } else {
                        dispatch({
                            type: "LOGIN",
                            payload: resJson
                        })
                        if ( resJson.user.isAdmin ) {
                            navigate('/admin_management', { replace: true})
                        } 
                        else if ( resJson.user.isSupervisor ) {
                            navigate('/supervisor', { replace: true})
                        }
                        else {
                            navigate('/results', { replace: true})
                        }
                    }
                } else {
                    setData({
                        ...data,
                        isSubmitting: false,
                        errorMessage: resJson.message || resJson.statusText
                    });

                }


            })
            .catch(error => {
                // console.log('Error:', error);
                setData({
                    ...data,
                    isSubmitting: false,
                    errorMessage: error.message || error.statusText
                });
            });
    };

    const handleAccountChoice = (accountType) => {
        setShowModal(false);
        dispatch({
            type: "LOGIN",
            payload: {
                ...accounts,
                user: accounts.accounts[accountType]
            }
        });
        
        if (accountType === 'supervisor') {
            navigate('/supervisor', { replace: true });
        } else {
            navigate('/results', { replace: true });
        }
    };

    return (
        <>
            <Container className="Login container subsection">

                <Form onSubmit={handleFormSubmit}>
                    <Form.Group size="lg" controlId="email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            autoFocus
                            type="email"
                            name="email"
                            value={data.email}
                            onChange={handleInputChange}
                        />
                    </Form.Group>
                    <Form.Group size="lg" controlId="password">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            type="password"
                            name="password"
                            value={data.password}
                            onChange={handleInputChange}
                        />
                    </Form.Group>

                    {data.errorMessage && (
                        <div className="form-error">
                            {data.errorMessage}
                        </div>
                    )}

                    <Button variant="danger" size="md" type="submit" disabled={data.isSubmitting} className="block mt-2">
                        {data.isSubmitting ? (
                            "Loading..."
                        ) : (
                            "Login"
                        )}
                    </Button>
                </Form>
            </Container>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Choose Account Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Please select how you would like to login:</p>
                    <div className="d-grid gap-2">
                        <Button variant="primary" onClick={() => handleAccountChoice('trainee')}>
                            Login as Trainee
                        </Button>
                        <Button variant="secondary" onClick={() => handleAccountChoice('supervisor')}>
                            Login as Supervisor
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default Login;
